"use client";

import { type FC, type PropsWithChildren, type ReactNode, useEffect, useState } from "react";
import { PageVariantContext, type VariantTypes, usePageVariantContext } from "../..";

type Props = PropsWithChildren;

export const PageVariantProvider: FC<Props> = (props) => {
	const { children } = props;
	const [variant, setVariant] = useState<VariantTypes | null>(null);

	return (
		<PageVariantContext.Provider value={{ variant, setVariant }}>
			{children}
		</PageVariantContext.Provider>
	);
};

export const PageVariantSetter = ({ variant }: { variant: VariantTypes }) => {
	const { setVariant } = usePageVariantContext();

	useEffect(() => {
		setVariant(variant);

		return () => {
			setVariant(null);
		};
	}, [variant, setVariant]);

	return null;
};

interface ShowOnPageVariantProps {
	children: ReactNode;
	variant: VariantTypes;
	fallback?: ReactNode;
}

export function ShowOnPageVariant({ children, variant, fallback = null }: ShowOnPageVariantProps) {
	const { variant: pageVariant } = usePageVariantContext();

	if (pageVariant !== variant) {
		return fallback;
	}

	return children;
}
